import i18n from '@/plugins/i18n';

export class Country {
    public id: number = 0;
    public name?: string;
    public selected: boolean = false;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    get value(): number {
        return this.id;
    }

    get text(): string | undefined {
        return i18n.t(`common.countries.${this.id}.name`).toString();
    }
}
